import React from 'react'
import { Link } from 'react-router-dom'

function Pricing() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Pricing</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Pricing Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6">
                    <div className="pricing_box mask-image contain" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/mask/mask_4.png)' }}>
                        <div className="main_price">
                            <h3 className="price mb-0">40</h3>
                            <div className="sub_text">
                                <p className="mb-0">99</p>
                                <p className="mb-0">3 Months</p>
                            </div>
                        </div>
                        <ul className="includes">
                            <li>Unlimited Club Access</li>
                            <li>Group Attendance</li>
                            <li>Gym Visits</li>
                            <li>Visits To The Bath Complex</li>
                            <li>Gym, Flight, Club</li>
                        </ul>
                        <Link to="/pricing" className="thm-btn btn-small">Buy Now</Link>
                    </div>
                </div>
               
                <div className="col-lg-4 col-md-6">
                    <div className="pricing_box mask-image contain" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/mask/mask_4.png)' }}>
                        <div className="main_price">
                            <h3 className="price mb-0">60</h3>
                            <div className="sub_text">
                                <p className="mb-0">99</p>
                                <p className="mb-0">5 Months</p>
                            </div>
                        </div>
                        <ul className="includes">
                            <li>Unlimited Club Access</li>
                            <li>Group Attendance</li>
                            <li>Gym Visits</li>
                            <li>Visits To The Bath Complex</li>
                            <li>Gym, Flight, Club</li>
                        </ul>
                        <Link to="/pricing" className="thm-btn btn-small">Buy Now</Link>
                    </div>
                </div>
                
                <div className="col-lg-4 col-md-6">
                    <div className="pricing_box mask-image contain" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/mask/mask_4.png)' }}>
                        <div className="main_price">
                            <h3 className="price mb-0">99</h3>
                            <div className="sub_text">
                                <p className="mb-0">99</p>
                                <p className="mb-0">7 Months</p>
                            </div>
                        </div>
                        <ul className="includes">
                            <li>Unlimited Club Access</li>
                            <li>Group Attendance</li>
                            <li>Gym Visits</li>
                            <li>Visits To The Bath Complex</li>
                            <li>Gym, Flight, Club</li>
                        </ul>
                        <Link to="/pricing" className="thm-btn btn-small">Buy Now</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Pricing